import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const response = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });

    return response.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

const authMultipartFetch = async (path, formData, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const response = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
      body: formData,
    });

    return response.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isDiscoverSectionsApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getDiscoverSectionsPayload = (res) => res?.data ?? null;

/** GET /admin/discover-sections */
export const getDiscoverSections = ({ competitionCid } = {}) => {
  const params = new URLSearchParams();
  if (competitionCid) params.set('competitionCid', String(competitionCid));
  const query = params.toString();
  return authFetch(`/admin/discover-sections${query ? `?${query}` : ''}`, { method: 'GET' });
};

/** POST /admin/discover-sections */
export const createDiscoverSection = (body) =>
  authFetch('/admin/discover-sections', { method: 'POST', body: JSON.stringify(body) });

/** POST /admin/discover-sections with multipart image */
export const createDiscoverSectionMultipart = (formData) =>
  authMultipartFetch('/admin/discover-sections', formData, { method: 'POST' });

/** PUT /admin/discover-sections/:id */
export const updateDiscoverSection = (id, body) =>
  authFetch(`/admin/discover-sections/${id}`, { method: 'PUT', body: JSON.stringify(body) });

/** PUT /admin/discover-sections/:id with multipart image */
export const updateDiscoverSectionMultipart = (id, formData) =>
  authMultipartFetch(`/admin/discover-sections/${id}`, formData, { method: 'PUT' });

/** POST /admin/discover-sections/upload-image */
export const uploadDiscoverSectionImage = (imageFile) => {
  const formData = new FormData();
  formData.append('image', imageFile);
  return authMultipartFetch('/admin/discover-sections/upload-image', formData, { method: 'POST' });
};

/** PATCH /admin/discover-sections/:id/enabled */
export const setDiscoverSectionEnabled = (id, enabled) =>
  authFetch(`/admin/discover-sections/${id}/enabled`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });

/** PUT /admin/discover-sections/:id/videos */
export const assignDiscoverSectionVideos = (id, videoIds, { makeLive = true } = {}) =>
  authFetch(`/admin/discover-sections/${id}/videos`, {
    method: 'PUT',
    body: JSON.stringify({ videoIds, makeLive }),
  });

/** GET /discover */
export const previewDiscover = ({ competitionCid } = {}) => {
  const params = new URLSearchParams();
  if (competitionCid) params.set('competitionCid', String(competitionCid));
  const query = params.toString();
  return authFetch(`/discover${query ? `?${query}` : ''}`, { method: 'GET' });
};
